import { isSameMonth } from "date-fns";
import LargeMonthViewEventChip from "./LargeMonthViewEventChip";
import LargeMonthViewNumbers from "./LargeMonthViewNumbers";
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const LargeMonthViewCalendar = ({dayObject, firstDayOfCurrentMonth, setEditEvent, setEventToEdit, setSelectedDay, setView, createNewCalendarEvent}) => {

    const goToDayView = (day) => {
      setSelectedDay({date: day, events: [], availabilities: []})
      setView('Day view')
    }

    const findTotalOfRealLessonEvents = (day) => {
      let totalLessonEvents = 0
      for(let i = 0; i < dayObject[day].events.length; i++) {
        if(!dayObject[day].events[i].isPendingOffer){
          totalLessonEvents++
        }
      }
      return totalLessonEvents
    }

    const checkForPendingOffers = (day) => {
      let pendingOffers = 0
      for(let i = 0; i < dayObject[day].events.length; i++) {
        if(dayObject[day].events[i].isPendingOffer){
          pendingOffers++
        }
      }
      return pendingOffers
    }

    const returnTimezoneSafeDateObject = (day) => {
      const [year, month, date] = day.split('-').map(Number);
      const newDate = new Date(year, month - 1, date);
      return newDate
    }

    const createDateObjectAndAddHours = (date) => {
      let e = returnTimezoneSafeDateObject(date)
      e.setHours(18)
      return e
    }

    return(
        <div className="hidden w-full lg:grid lg:grid-cols-7 lg:grid-rows-5 lg:gap-px md:grid md:grid-cols-7 md:grid-rows-5 md:gap-px sm:grid sm:grid-cols-7 sm:grid-rows-5 sm:gap-px text-left">
          {Object.keys(dayObject).map((day) => (
            <div key={day} onClick={(e) => (e.target.id !== 'date-number' && e.target.id !== 'existing-event') && createNewCalendarEvent(createDateObjectAndAddHours(day))} className={classNames(isSameMonth(returnTimezoneSafeDateObject(day), firstDayOfCurrentMonth) ? 'bg-white text-gray-600' : 'bg-blue-50 text-gray-300', 'relative py-1 px-1')}>
              <div>
                <LargeMonthViewNumbers day={day} goToDayView={goToDayView} />
                {checkForPendingOffers(day) > 0 && <div className="absolute top-1 right-1 w-4 h-4 bg-orange-500 rounded-full text-white text-xs flex justify-center items-center">{checkForPendingOffers(day)}</div>}
              </div>
              {dayObject[day].events.length > 0 && (
                <ol className="mt-2">
                  {dayObject[day].events.slice(0, 2).map((event) => !event.isPendingOffer && <LargeMonthViewEventChip key={event.id} event={event} setEditEvent={setEditEvent} setEventToEdit={setEventToEdit} />)}
                  {findTotalOfRealLessonEvents(day) > 2 && <li id="existing-event" onClick={() => goToDayView(returnTimezoneSafeDateObject(day))} className="list-none text-xs text-black cursor-pointer text-left ml-1 my-1 transition-text duration-300 hover:text-gray-700">{findTotalOfRealLessonEvents(day) - 1} more...</li>}
                </ol>
              )}
            </div>
          ))}
        </div>
    )
}
export default LargeMonthViewCalendar;